<div>
  <section>
    <div class="row mx-0 mb-2">
      <div class="col-10 px-0">
        <h3>
          Encounter Types
        </h3>
      </div>
    </div>

    <app-encounter-type-eligibilities-explainer
      [expanded]="this.uiOptions.explainerExpanded"
      (expandOrCollapse)="onExplainerExpandOrCollapse($event)" />

    <div class="container-fluid p-2 border rounded bg-light mb-4">
      <h5>New Encounter Types</h5>

      @if (newClientEncounterTypeEligibilities && newClientEncounterTypeEligibilities.length > 0) {
        <p><em>NOTE: Data from encounter types in this list will not be used to capture claims until review is completed.</em></p>

        <app-client-encounter-type-eligibility-table
          [label]="'new encounter types'"
          [paging]="newPaging"
          [loading]="newLoading"
          [showClient]="false"
          [clientEncounterTypeEligibilities]="newClientEncounterTypeEligibilities"
          (pageSizeChange)="onNewPageSizeChange($event)"
          (pageChange)="onNewPageChange($event)" />
      } @else {
        <p>No new encounter types. All encounter types have been reviewed.</p>
      }
    </div>

    <div class="container-fluid p-2 border rounded bg-light mb-2">
      <h5>Current Encounter Types</h5>
      <p><em>Are encounter types missing? If yes please reach out to your NuvemRx contact to revisit your organization's data feed.</em></p>

      <form>
        <div class="row align-items-end">

          <div class="col-2">
            <div class="mb-3">
              <label><strong>Eligibility Status:</strong></label>
              <ng-select
                class="w-100"
                bindValue="value"
                bindLabel="display"
                name="eligibilityStatus"
                placeholder="Filter by Status"
                [multiple]="true"
                [items]="eligibilityStatusFilterOptions"
                (remove)="onFilterChange()"
                (change)="onFilterChange()"
                [(ngModel)]="filters.eligibilityStatuses" />
            </div>
          </div>

          <div class="col-2">
            <div class="mb-3">
              <label><strong>Encounter Types:</strong></label>
              <input
                type="text"
                class="form-control"
                name="encounterType"
                placeholder="Filter by Encounter Type"
                [(ngModel)]="filters.encounterType"
                (keyup)="onEncounterTypeKeyUp()" />
            </div>
          </div>

          <div class="col-auto mb-3">
            <button type="button" class="btn btn-info mt-0 clear-button" (click)="onResetFiltersClick()">Clear</button>
          </div>

        </div>
      </form>

      <app-client-encounter-type-eligibility-table
        [label]="'encounter types'"
        [paging]="paging"
        [loading]="loading"
        [showClient]="false"
        [clientEncounterTypeEligibilities]="clientEncounterTypeEligibilities"
        (pageSizeChange)="onPageSizeChange($event)"
        (pageChange)="onPageChange($event)" />
    </div>

  </section>
</div>
